import yup from "../validation/yup";

export const loginSchema = yup.object().shape({
  userName: yup.string().label("Usuario").required(),
  password: yup.string().label("Contraseña").required(),
  rememberMe: yup.bool().label("Recordarme"),
});
